<section class="header-section section-spacing bg-grey">
    <div class="container">
    <div class="row mx-0 align-items-center">
        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
        <h1 class="header-title text-start mb-0">
            <span>IT Assets Management <br /> for BFSI</span>
        </h1>
        <p class="header-desc text-start mx-0 w-100" style="margin: 24px 0">
            Streamline Your Assets, Future-Proof Your Business
        </p>
        </div>
    </div>
    </div>
</section>

<section class="container section-spacing feature-1-section">
    <div
    class="main-feature-wrapper section-spacing"
    style="background-position: top right 50px"
    >
    <div class="feature-1-content-wrapper">
        <h2 class="section-title">What is ITAM for BFSI?</h2>
        <p class="section-paragraph">
        ITAM for BFSI is a comprehensive solution designed to manage and
        optimize the lifecycle of IT assets within the banking, financial
        services, and insurance sectors. It ensures operational efficiency
        and compliance through effective asset tracking and management.
        <br />
        It focuses on managing and optimizing the lifecycle of IT assets to
        ensure compliance, reduce risks, and maximize efficiency in these
        highly regulated industries.
        </p>
    </div>
    <div class="feature-1-img-wrapper"></div>
    </div>
    <div
    class="main-feature-wrapper section-spacing"
    style="background-position: top left 50px"
    >
    <div class="feature-1-img-wrapper"></div>
    <div class="feature-1-content-wrapper">
        <h2 class="section-title">What does ITAM do for BFSI?</h2>
        <p class="section-paragraph">
        Infraon ITAM provides the BFSI sector with tools to efficiently
        track, manage, and report on their IT assets. This visibility
        reduces costs, enhances security, and ensures compliance with
        industry regulations, supporting strategic decision-making.
        <br />
        Through ITAM, BFSI firms can achieve operational excellence and
        enhance their cybersecurity posture.
        </p>
    </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
    Key Benefits of ITAM for BFSI
    </h2>

    <div class="row mx-0 align-items-center section-spacing pt-0">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-left">
        <h3 class="section-title">Enhanced Security</h3>
        <p class="section-paragraph">
            Ensure the security of sensitive financial data with robust asset
            management controls, significantly reducing vulnerability and the
            risk of data breaches. <br />
            ITAM offers advanced tools and practices to safeguard client
            information and institutional financial details from cyber threats
            and attacks, reinforcing your cybersecurity framework.
        </p>
        </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-3.webp"
        class="w-100"
        alt="employees handshake"
        />
    </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-4.webp"
        class="w-90"
        alt="regulatory compliance"
        />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-right">
        <h3 class="section-title">Regulatory Compliance</h3>
        <p class="section-paragraph">
            Through comprehensive asset tracking and documentation, you can
            easily meet stringent BFSI regulations. ITAM enables the
            maintenance of up-to-date records of IT assets, ensuring full
            compliance with industry standards and laws. <br />
            Hefty penalties and legal complications can be avoided by ensuring
            that audits are passed smoothly and regulatory requirements are
            met with precision.
        </p>
        </div>
    </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-left">
        <h3 class="section-title">Cost Reduction</h3>
        <p class="section-paragraph">
            Identify underutilized assets and optimize investments to
            significantly reduce IT expenditures and increase the return on
            investment (ROI). <br />
            BFSI organizations can make informed decisions about asset
            reallocation, retirement, or further acquisition, minimizing
            unnecessary spending and maximizing the value derived from each
            asset.
        </p>
        </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-5.webp"
        class="w-100"
        alt="cosdt Reduction"
        />
    </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-6.webp"
        class="w-90"
        alt="improved efficiency"
        />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-right">
        <h3 class="section-title">Improved Efficiency</h3>
        <p class="section-paragraph">
            Automate asset lifecycle management to streamline operations,
            freeing valuable resources and allowing the focus to shift towards
            core financial services and innovation. <br />
            Reduce manual workload, minimize errors, and accelerate processes,
            from procurement to disposal, enhancing overall organizational
            productivity and enabling faster response to market changes.
        </p>
        </div>
    </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-left">
        <h3 class="section-title">Data-driven Planning Support</h3>
        <p class="section-paragraph">
            Gain deeper insights into asset performance and usage patterns,
            aiding in informed decision-making and strategic IT planning.
            <br />
            This intelligence helps forecast future needs, assess current
            capabilities, and identify opportunities. It enables long-term
            strategic alignment and agility in the constantly evolving
            financial sector.
        </p>
        </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-7.webp"
        class="w-100"
        alt="data-driven planning support"
        />
    </div>
    </div>

    <div
    class="row mx-0 align-items-center section-spacing pb-0 reverse-column"
    >
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <img
        loading="lazy"
        src="/assets/img/feature-pages/infraon-assets/assets-bfsi/assets-bfsi-feature-8.webp"
        class="w-90"
        alt="Disaster recovery"
        />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="illustrated-feature-container-text-right">
        <h3 class="section-title">Disaster Recovery</h3>
        <p class="section-paragraph">
            Quickly recover from data breaches or disasters with comprehensive
            asset inventories, minimizing downtime and financial losses.
            <br />
            Ensure recovery processes are clearly defined to restore
            operations swiftly after an incident, significantly reducing the
            impact of disasters on financial operations and client trust,
            safeguarding reputation and continuity.
        </p>
        </div>
    </div>
    </div>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">Using Infraon's ITAM for BFSI</h2>

    <div class="row mx-0 feature-box">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
        >
            <path
            d="M0 15.6027C0 14.2824 1.06641 13.1652 2.4375 13.1652H8.9375C10.2578 13.1652 11.375 14.2824 11.375 15.6027V21.2902C11.375 22.6613 10.2578 23.7277 8.9375 23.7277H2.4375C1.06641 23.7277 0 22.6613 0 21.2902V15.6027ZM15.4375 0.977722H23.5625C24.8828 0.977722 26 2.09491 26 3.41522V5.04022C26 6.41132 24.8828 7.47772 23.5625 7.47772H15.4375C14.0664 7.47772 13 6.41132 13 5.04022V3.41522C13 2.09491 14.0664 0.977722 15.4375 0.977722ZM13 11.5402C13 10.2199 14.0664 9.10272 15.4375 9.10272H23.5625C24.8828 9.10272 26 10.2199 26 11.5402V13.1652C26 14.5363 24.8828 15.6027 23.5625 15.6027H15.4375C14.0664 15.6027 13 14.5363 13 13.1652V11.5402ZM15.4375 17.2277H23.5625C24.8828 17.2277 26 18.3449 26 19.6652V21.2902C26 22.6613 24.8828 23.7277 23.5625 23.7277H15.4375C14.0664 23.7277 13 22.6613 13 21.2902V19.6652C13 18.3449 14.0664 17.2277 15.4375 17.2277Z"
            fill="#A8C0F1"
            />
            <path
            d="M0 3.54022C0 2.21991 1.06641 1.10272 2.4375 1.10272H8.9375C10.2578 1.10272 11.375 2.21991 11.375 3.54022V9.22772C11.375 10.5988 10.2578 11.6652 8.9375 11.6652H2.4375C1.06641 11.6652 0 10.5988 0 9.22772V3.54022Z"
            fill="#1A5AD9"
            />
        </svg>
        <h3 class="section-title text-start">
            Comprehensive Asset Discovery
        </h3>
        <p class="section-paragraph text-start">
            Automatically discover and document IT assets across the network.
            Ensure no asset goes unnoticed or unmanaged, reducing the risk of
            operational inefficiencies and providing a solid foundation for IT
            governance and decision-making.
        </p>
        </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
            d="M14 0.727722C21.7109 0.727722 28 7.01678 28 14.7277C28 22.4933 21.7109 28.7277 14 28.7277C6.23438 28.7277 0 22.4933 0 14.7277C0 10.8449 1.58594 7.29022 4.15625 4.7746L5.41406 3.51678L7.875 6.03241L6.61719 7.23553C4.70312 9.1496 3.5 11.8293 3.5 14.7277C3.5 20.5246 8.20312 25.2277 14 25.2277C19.7969 25.2277 24.5 20.5246 24.5 14.7277C24.5 9.53241 20.6719 5.2121 15.75 4.39178V5.97772V7.72772H12.25V5.97772V2.47772V0.727722H14Z"
            fill="#084CD4"
            />
            <path
            d="M11.2891 10.1574H11.2344L15.6094 14.5324L16.5391 15.4621L14.7344 17.3215L13.8047 16.3918L9.42969 12.0168L8.5 11.0871L10.3594 9.22772L11.2891 10.1574Z"
            fill="#A8C1F1"
            />
        </svg>
        <h3 class="section-title text-start">Real-time Asset Monitoring</h3>
        <p class="section-paragraph text-start">
            Enable continuous monitoring of the health and performance of IT
            assets in real-time, ensuring uninterrupted service delivery, and
            IT infrastructure's reliability, for improved customer
            satisfaction and operational excellence.
        </p>
        </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="29"
            viewBox="0 0 21 29"
            fill="none"
        >
            <path
            d="M0 0.727722H12.25V9.47772H21V28.7277H0V0.727722Z"
            fill="#084CD4"
            />
            <path d="M21 7.72772H14V0.727722L21 7.72772Z" fill="#A8C1F1" />
        </svg>
        <h3 class="section-title text-start">
            Contract & License Management
        </h3>
        <p class="section-paragraph text-start">
            Manage contracts and licenses efficiently, ensuring compliance and
            optimizing software expenditures.
        </p>
        </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="28"
            viewBox="0 0 21 28"
            fill="none"
        >
            <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
            <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
            <g clip-path="url(#clip0_3_343)">
            <path
                d="M12.0833 13.25C12.1928 13.1406 12.3227 13.0538 12.4657 12.9945C12.6087 12.9353 12.7619 12.9048 12.9167 12.9048C13.0714 12.9048 13.2247 12.9353 13.3677 12.9945C13.5107 13.0538 13.6406 13.1406 13.75 13.25C13.8594 13.3594 13.9463 13.4894 14.0055 13.6323C14.0647 13.7753 14.0952 13.9286 14.0952 14.0833C14.0952 14.2381 14.0647 14.3913 14.0055 14.5343C13.9463 14.6773 13.8594 14.8072 13.75 14.9167L8.12501 20.5417L5.83334 21.1667L6.45834 18.875L12.0833 13.25Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            </g>
            <defs>
            <clipPath id="clip0_3_343">
                <rect
                width="10"
                height="10"
                fill="white"
                transform="translate(5 12)"
                />
            </clipPath>
            </defs>
        </svg>
        <h3 class="section-title text-start">Customizable Reporting</h3>
        <p class="section-paragraph text-start">
            Generate detailed reports tailored to specific needs, providing
            insights into asset utilization and compliance statuses.
        </p>
        </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
        >
            <path
            d="M26.2523 7.65625C26.1976 13.125 23.9554 23.0234 14.5492 27.5625C13.6195 28 12.5804 28 11.6507 27.5625C2.24448 23.0234 0.00229412 13.125 0.00229412 7.65625C-0.0523934 6.23438 0.877294 5.08594 2.08042 4.53906L12.3617 0.164062C12.5804 0.109375 12.8539 0 13.1273 0C13.346 0 13.6195 0.109375 13.8382 0.164062L24.1195 4.53906C25.3226 5.08594 26.2523 6.23438 26.2523 7.65625ZM11.8148 3.28125L3.11948 6.94531C2.79136 7.10938 2.57261 7.38281 2.62729 7.65625C2.62729 12.4688 4.54136 20.5625 11.8148 24.6641V3.28125Z"
            fill="#1A5AD9"
            />
        </svg>
        <h3 class="section-title text-start">
            Security & Compliance Tools
        </h3>
        <p class="section-paragraph text-start">
            Tools integrated with asset management designed for BFSI to manage
            risk, ensure security, and maintain compliance with ease.
        </p>
        </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="feature-wrapper">
        <svg
            style="max-height: 26px"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="31"
            viewBox="0 0 32 31"
            fill="none"
        >
            <path
            d="M25.3438 30.582L24.3789 29.4649C24.0234 29.5156 23.668 29.5156 23.3125 29.5156C22.957 29.5156 22.6016 29.5156 22.2461 29.4649L21.2305 30.582C20.9258 30.9375 20.418 31.0899 19.9609 30.8867C19.707 30.7852 19.4023 30.6328 19.1484 30.4805L18.8945 30.3281C18.6406 30.1758 18.3867 30.0234 18.1328 29.8203C17.7773 29.5664 17.625 29.0586 17.7773 28.6016L18.2852 27.1797C17.8281 26.6211 17.4727 26.0117 17.2188 25.3008L15.7461 24.9961C15.2383 24.8945 14.8828 24.5391 14.832 24.082C14.7812 23.7266 14.7812 23.3711 14.7812 23.0156C14.7812 22.6602 14.7812 22.3555 14.832 22C14.8828 21.543 15.2383 21.1367 15.7461 21.0352L17.2188 20.7305C17.4727 20.0703 17.8281 19.4609 18.2852 18.9024L17.7773 17.4805C17.625 17.0234 17.7773 16.5156 18.1328 16.2109C18.3867 16.0586 18.6406 15.8555 18.8945 15.7031L19.1484 15.5508C19.4023 15.4492 19.707 15.2969 19.9609 15.1953C20.418 14.9922 20.9258 15.1445 21.2305 15.5L22.2461 16.6172C22.5508 16.5664 22.9063 16.5664 23.3125 16.5664C23.668 16.5664 24.0234 16.5664 24.3281 16.6172L25.3438 15.5C25.6992 15.1445 26.207 14.9922 26.6133 15.1953C26.918 15.2969 27.1719 15.4492 27.4258 15.5508L27.6797 15.7031C27.9336 15.9063 28.1875 16.0586 28.4414 16.2109C28.7969 16.5156 28.9492 17.0234 28.7969 17.4805L28.3398 18.9024C28.7461 19.4609 29.1016 20.0703 29.3555 20.7305L30.8789 21.0859C31.3359 21.1875 31.6914 21.543 31.7422 22C31.793 22.3555 31.8438 22.7109 31.8438 23.0664C31.8438 23.3711 31.793 23.7266 31.7422 24.082C31.6914 24.5391 31.3359 24.9453 30.8789 24.9961L29.3555 25.3516C29.1523 26.0117 28.7461 26.6211 28.3398 27.1797L28.7969 28.6016C28.9492 29.0586 28.7969 29.5664 28.4414 29.8711C28.1875 30.0234 27.9336 30.1758 27.6797 30.3281L27.4258 30.5313C27.1719 30.6328 26.918 30.7852 26.6133 30.8867C26.1563 31.0899 25.6992 30.9375 25.3438 30.582ZM23.3125 25.4531C24.6328 25.4531 25.75 24.3867 25.75 23.0156C25.75 21.6953 24.6328 20.5781 23.3125 20.5781C21.9414 20.5781 20.875 21.6953 20.875 23.0156C20.875 24.3867 21.9414 25.4531 23.3125 25.4531Z"
            fill="#AB67F0"
            />
            <path
            d="M15.4777 7.39062L14.3605 8.35547C14.4113 8.71094 14.4113 9.06641 14.4113 9.42188C14.4113 9.77734 14.4113 10.1328 14.3605 10.4883L15.4777 11.5039C15.8332 11.8086 15.9855 12.3164 15.7824 12.7734C15.6808 13.0273 15.5285 13.332 15.3761 13.5859L15.2238 13.8398C15.0714 14.0938 14.9191 14.3477 14.7668 14.6016C14.4621 14.957 13.9543 15.1094 13.4972 14.957L12.0754 14.4492C11.5168 14.9062 10.9074 15.2617 10.1964 15.5156L9.89176 16.9883C9.7902 17.4961 9.43473 17.8516 8.9777 17.9023C8.62223 17.9531 8.26676 17.9531 7.91129 17.9531C7.60661 17.9531 7.25114 17.9531 6.89567 17.9023C6.43864 17.8516 6.03239 17.4961 5.98161 16.9883L5.62614 15.5156C4.96598 15.2617 4.3566 14.9062 3.79801 14.4492L2.37614 14.957C1.9191 15.1094 1.41129 14.957 1.1066 14.6016C0.954261 14.3477 0.751136 14.0938 0.598792 13.8398L0.446449 13.5859C0.344886 13.332 0.192542 13.0273 0.0909798 12.7734C-0.112145 12.3164 0.0401986 11.8086 0.395667 11.5039L1.51285 10.4883C1.46207 10.1836 1.46207 9.82812 1.46207 9.42188C1.46207 9.06641 1.46207 8.71094 1.51285 8.40625L0.395667 7.39062C0.0401986 7.03516 -0.112145 6.57812 0.0909798 6.12109C0.192542 5.81641 0.344886 5.5625 0.446449 5.30859L0.598792 5.05469C0.801917 4.80078 0.954261 4.54688 1.1066 4.29297C1.41129 3.9375 1.9191 3.78516 2.37614 3.9375L3.79801 4.39453C4.3566 3.98828 4.96598 3.63281 5.67692 3.37891L5.98161 1.85547C6.08317 1.39844 6.43864 1.04297 6.89567 0.992188C7.25114 0.941406 7.60661 0.890625 7.96207 0.890625C8.26676 0.890625 8.62223 0.941406 8.9777 0.992188C9.43473 1.04297 9.84098 1.39844 9.94254 1.90625L10.2472 3.37891C10.9074 3.58203 11.5168 3.98828 12.0754 4.39453L13.4972 3.9375C13.9543 3.78516 14.4621 3.9375 14.7668 4.29297C14.9191 4.54688 15.1222 4.80078 15.2746 5.05469L15.4269 5.30859C15.5285 5.5625 15.6808 5.81641 15.7824 6.12109C15.9855 6.57812 15.8332 7.03516 15.4777 7.39062ZM10.3996 9.42188C10.3996 8.10156 9.28239 6.98438 7.96207 6.98438C6.59098 6.98438 5.52457 8.10156 5.52457 9.42188C5.52457 10.793 6.59098 11.8594 7.96207 11.8594C9.28239 11.8594 10.3996 10.793 10.3996 9.42188Z"
            fill="#084CD4"
            />
        </svg>
        <h3 class="section-title text-start">Scalable Architecture</h3>
        <p class="section-paragraph text-start">
            A flexible and scalable solution that grows with your financial
            institution, accommodating new assets and technologies
            effortlessly.
        </p>
        </div>
    </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="" style="background-color: transparent;color: var(--title);">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
        <a
        routerLink="/it-asset-management/features/it-assets-management-solutions"
        >
        <div class="backlink-wrapper">
            <div class="backlink-thumbnail-wrapper">
            <img
                src="/assets/img/feature-pages/infraon-assets/assets-bfsi/itam-thumbnail-01.webp"
                class="w-100 backlink-thumbnail"
                alt="IT Asset Management Thumbnail"
            />
            </div>
            <div class="backlink-container bg-white">
            <p class="section-title-s text-start">IT Asset Management</p>
            <p class="primary-color mb-0">Know more</p>
            </div>
        </div>
        </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
        <a
        routerLink="/it-asset-management/features/software-assets-management-solutions"
        >
        <div class="backlink-wrapper">
            <div class="backlink-thumbnail-wrapper">
            <img
                src="/assets/img/feature-pages/infraon-assets/assets-bfsi/sam-thumbnail-01.webp"
                class="w-100 backlink-thumbnail"
                alt="Software Asset Management Thumbnail"
            />
            </div>
            <div class="backlink-container bg-white">
            <p class="section-title-s text-start">
                Software Asset Management
            </p>
            <p class="primary-color mb-0">Know more</p>
            </div>
        </div>
        </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
        <a routerLink="/itsm-tool">
        <div class="backlink-wrapper">
            <div class="backlink-thumbnail-wrapper">
            <img
                src="/assets/img/feature-pages/infraon-assets/assets-bfsi/software-license-management.webp"
                class="w-100 backlink-thumbnail"
                alt="Software License Management Thumbnail"
            />
            </div>
            <div class="backlink-container bg-white">
            <p class="section-title-s text-start">
                Software License Management
            </p>
            <p class="primary-color mb-0">Know more</p>
            </div>
        </div>
        </a>
    </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>